<mat-progress-bar [mode]="pbMode" value="pbValue"></mat-progress-bar>
